<script setup lang="ts">

</script>

<template>
  <div class="flex flex-col">
    <slot/>
  </div>
</template>

<style scoped>

</style>
